import React, { useState } from 'react';

const GDPRPage: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <div className="website-container">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo">
            <a href="/" className="logo-link">
              <img src="/assets/LogoBrown.png" alt="SobCof Logo" className="logo-img" />
            </a>
          </div>
          <div className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
            <a href="/" className="nav-link">Ana Sayfa</a>
            <a href="/#features" className="nav-link">Özellikler</a>
            <a href="/#how-it-works" className="nav-link">Nasıl Çalışır</a>
            <a href="/#download" className="nav-link">İndir</a>
            <a href="/contact" className="nav-link">İletişim</a>
            <a href="/cafe-partnership" className="nav-link">Kafe Partnerliği</a>
          </div>
          <div className="nav-toggle" onClick={toggleMobileMenu}>
            <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </div>
        </div>
      </nav>

      {/* Legal Content */}
      <section className="legal-content">
        <div className="container">
          <div className="legal-header">
            <h1>KVKK ve GDPR Uyumluluğu</h1>
          </div>

          <div className="legal-body">
            <div className="section">
              <h2>1. Genel Bakış</h2>
              <p>
                SobCof olarak, Kişisel Verilerin Korunması Kanunu (KVKK) ve Avrupa Birliği 
                Genel Veri Koruma Tüzüğü (GDPR) gerekliliklerine tam uyum sağlıyoruz.
              </p>
            </div>

            <div className="section">
              <h2>3. Kişisel Veri İşleme Amaçları</h2>
              <p>Kişisel verilerinizi aşağıdaki amaçlarla işliyoruz:</p>
              <ul>
                <li>Hizmet sağlama ve kullanıcı deneyimi</li>
                <li>Güvenlik ve dolandırıcılık önleme</li>
                <li>Yasal yükümlülüklerin yerine getirilmesi</li>
                <li>İstatistik ve analiz</li>
                <li>Pazarlama ve iletişim (onay ile)</li>
              </ul>
            </div>

            <div className="section">
              <h2>4. Haklarınız</h2>
              <p>KVKK ve GDPR kapsamında sahip olduğunuz haklar:</p>
              
              <div className="rights-grid">
                <div className="right-card">
                  <h4><i className="fas fa-eye"></i> Bilgi Alma Hakkı</h4>
                  <p>Hangi kişisel verilerinizin işlendiğini öğrenme hakkınız vardır.</p>
                </div>

                <div className="right-card">
                  <h4><i className="fas fa-edit"></i> Düzeltme Hakkı</h4>
                  <p>Yanlış veya eksik verilerinizin düzeltilmesini talep edebilirsiniz.</p>
                </div>

                <div className="right-card">
                  <h4><i className="fas fa-trash"></i> Silme Hakkı</h4>
                  <p>Belirli koşullarda verilerinizin silinmesini isteyebilirsiniz.</p>
                </div>

                <div className="right-card">
                  <h4><i className="fas fa-ban"></i> İtiraz Hakkı</h4>
                  <p>Veri işleme faaliyetlerine itiraz edebilirsiniz.</p>
                </div>

                <div className="right-card">
                  <h4><i className="fas fa-download"></i> Taşınabilirlik Hakkı</h4>
                  <p>Verilerinizi yapılandırılmış formatta alabilirsiniz.</p>
                </div>

                <div className="right-card">
                  <h4><i className="fas fa-pause"></i> Sınırlama Hakkı</h4>
                  <p>Veri işlemenin sınırlanmasını talep edebilirsiniz.</p>
                </div>
              </div>
            </div>

            <div className="section">
              <h2>5. Veri İşleme Süreçleri</h2>
              
              <h3>5.1 Toplama</h3>
              <ul>
                <li>Açık rıza ile</li>
                <li>Hizmet sağlama için gerekli olduğunda</li>
                <li>Yasal yükümlülük gereği</li>
              </ul>

              <h3>5.2 Saklama</h3>
              <ul>
                <li>Amaç sona erene kadar</li>
                <li>Yasal saklama süreleri</li>
                <li>Kullanıcı talebi ile silme</li>
              </ul>

              <h3>5.3 Paylaşım</h3>
              <ul>
                <li>Sadece gerekli durumlarda</li>
                <li>Uygun güvenlik önlemleri ile</li>
                <li>Veri işleme sözleşmeleri ile</li>
              </ul>
            </div>

            <div className="section">
              <h2>6. Güvenlik Önlemleri</h2>
              <ul>
                <li>End-to-end şifreleme</li>
                <li>Erişim kontrolü ve yetkilendirme</li>
                <li>Düzenli güvenlik denetimleri</li>
                <li>Veri minimizasyonu ilkesi</li>
                <li>Pseudonimleştirme ve anonimleştirme</li>
                <li>Veri ihlali bildirimi prosedürleri</li>
              </ul>
            </div>

            <div className="section">
              <h2>7. Uluslararası Veri Aktarımı</h2>
              <p>
                Verileriniz AB dışına aktarılırken aşağıdaki güvenceler sağlanır:
              </p>
              <ul>
                <li>Yeterlilik kararları</li>
                <li>Standart sözleşme hükümleri</li>
                <li>Bağlayıcı kurumsal kurallar</li>
                <li>Sertifikasyon mekanizmaları</li>
              </ul>
            </div>

            <div className="section">
              <h2>8. Çocukların Verilerinin Korunması</h2>
              <p>
                16 yaşından küçük çocukların verilerini işlemiyoruz. 
                Eğer böyle bir durumla karşılaşırsak, verileri derhal sileriz.
              </p>
            </div>

            <div className="section">
              <h2>9. Veri İhlali Bildirimi</h2>
              <p>
                Veri ihlali durumunda:
              </p>
              <ul>
                <li>72 saat içinde ilgili otoritelere bildirim</li>
                <li>Yüksek risk durumunda kullanıcılara bildirim</li>
                <li>Gerekli önlemlerin alınması</li>
                <li>İhlal kaydının tutulması</li>
              </ul>
            </div>

            <div className="section">
              <h2>10. Şikayet Hakkı</h2>
              <p>
                Veri işleme faaliyetlerimizden memnun değilseniz, 
                aşağıdaki otoritelere şikayette bulunabilirsiniz:
              </p>
              <ul>
                <li><strong>Türkiye:</strong> Kişisel Verileri Koruma Kurumu (KVKK)</li>
                <li><strong>AB:</strong> İlgili ülkenin veri koruma otoritesi</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <div className="footer-logo">
                <a href="/" className="logo-link">
                  <img src="/assets/LogoWhite.png" alt="SobCof Logo" />
                </a>
              </div>
              <p className="footer-description">
                Kahve severler için sosyal keşif platformu. En iyi kafeleri keşfet, yeni insanlarla tanış.
              </p>
              <div className="social-links">
                <a href="https://instagram.com/sobcof" title="Instagram" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                <a href="https://tiktok.com/@sobcof" title="TikTok" target="_blank" rel="noopener noreferrer"><i className="fab fa-tiktok"></i></a>
                <a href="https://twitter.com/sobcof" title="Twitter" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
                <a href="https://youtube.com/@sobcof" title="YouTube" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
              </div>
            </div>

            <div className="footer-section">
              <h4>Ürün</h4>
              <ul>
                <li><a href="/#features">Özellikler</a></li>
                <li><a href="/#premium">Premium</a></li>
                <li><a href="/#download">İndir</a></li>
                <li><a href="/#security">Güvenlik</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Destek</h4>
              <ul>
                <li><a href="/help">Yardım Merkezi</a></li>
                <li><a href="/contact">İletişim</a></li>
                <li><a href="/feedback">Geri Bildirim</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Yasal</h4>
              <ul>
                <li><a href="/privacy">Gizlilik Politikası</a></li>
                <li><a href="/terms">Kullanım Koşulları</a></li>
                <li><a href="/cookies">Çerez Politikası</a></li>
                <li><a href="/gdpr">KVKK</a></li>
              </ul>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; 2026 SobCof. Tüm hakları saklıdır.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default GDPRPage;
